<template>
  <div>
    <base-header class="pb-6" type="indigo">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Edit Company</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
      ></loading>

      <b-row v-if="company">
        <b-col cols="12" xl="10" offset-xl="1">
          <b-card>
            <validation-observer v-slot="{ valid, handleSubmit }">
              <b-form role="form" @submit.prevent="handleSubmit(updateCompany)">
                <b-card-body>
                  <!-- Basic fields -->
                  <b-row class="border-bottom pb-3">
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Registration</h4>
                      <p class="text-muted">
                        Only Isle of Man 1931 Act Companies are currently
                        supported.
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <b-row>
                        <b-col cols="12" md="6">
                          <base-input label="Jurisdiction" name="Jurisdiction">
                            <select
                              class="form-control"
                              v-model="company.jurisdiction"
                            >
                              <option value="isle_of_man">Isle of Man</option>
                            </select>
                          </base-input>
                        </b-col>

                        <b-col cols="12" md="6">
                          <base-input label="Entity Type" name="Entity Type">
                            <select class="form-control" v-model="company.type">
                              <option
                                value="iom_1931_act_company_limited_by_shares"
                              >
                                1931 Act Company (Limited By Shares)
                              </option>
                            </select>
                          </base-input>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="12" md="6">
                          <base-input
                            label="Company Name"
                            name="Name"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. Company Name Limited"
                            v-model="company.name"
                          ></base-input>
                        </b-col>
                        <b-col cols="12" md="6">
                          <base-input
                            label="Company Number"
                            name="Number"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. 80619C"
                            v-model="company.number"
                          ></base-input>
                        </b-col>
                      </b-row>

                      <!-- address -->
                      <base-input
                        label="Registered Address"
                        name="Address"
                        :rules="{ required: true }"
                      >
                        <!-- TODO: make field required in validation rules -->
                        <address-autocomplete-input
                          v-model="company.address"
                          placeholder="e.g. 12 Marine Drive, Douglas, IM8 XE1"
                        >
                        </address-autocomplete-input>
                      </base-input>

                      <b-row>
                        <!-- incorp date -->
                        <b-col cols="12" md="6">
                          <base-input
                            label="Incorporation Date"
                            name="Incorporation Date"
                            type="date"
                            v-model="company.incorporationDate"
                          ></base-input>
                        </b-col>
                        <!-- status -->
                        <b-col cols="12" md="6">
                          <base-input label="Status" name="Status">
                            <select
                              class="form-control"
                              v-model="company.status"
                            >
                              <option value="active">Active</option>
                              <option value="dissolved">Dissolved</option>
                            </select>
                          </base-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row class="border-bottom py-3">
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Business Information</h4>
                      <p class="text-muted">
                        Please provide some more information about the company
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <b-row>
                        <b-col>
                          <base-input
                            label="Main Business Activity"
                            name="Activity"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. Wholesale Beverage Distribution"
                            v-model="company.businessActivity"
                          ></base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <!-- incorp date -->
                        <b-col cols="12" md="6">
                          <base-input
                            label="Reporting Currency"
                            name="Currency"
                          >
                            <select
                              class="form-control"
                              v-model="company.currency"
                            >
                              <option
                                v-for="currency in currencies"
                                :key="currency.code"
                                :value="currency.code"
                              >
                                {{ currency.currency }} ({{ currency.code }})
                              </option>
                              <option value="active">Active</option>
                              <option value="dissolved">Dissolved</option>
                            </select>
                          </base-input>
                        </b-col>
                        <!-- status -->
                        <b-col cols="12" md="6">
                          <b-row>
                            <b-col cols="7">
                              <base-input
                                label="Year end (month)"
                                name="Year end month"
                              >
                                <select
                                  class="form-control"
                                  v-model="yearEndMonth"
                                >
                                  <option value="01">January</option>
                                  <option value="02">February</option>
                                  <option value="03">March</option>
                                  <option value="04">April</option>
                                  <option value="05">May</option>
                                  <option value="06">June</option>
                                  <option value="07">July</option>
                                  <option value="08">August</option>
                                  <option value="09">September</option>
                                  <option value="10">October</option>
                                  <option value="11">November</option>
                                  <option value="12">December</option>
                                </select>
                              </base-input>
                            </b-col>
                            <b-col cols="5">
                              <base-input label="(day)" name="Year end day">
                                <select
                                  class="form-control"
                                  v-model="yearEndDay"
                                >
                                  <option
                                    v-for="date in yearEndDays"
                                    :key="date.value"
                                    :value="date.value"
                                    :disabled="date.disabled"
                                  >
                                    {{ date.label }}
                                  </option>
                                </select>
                              </base-input>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row
                    class="pt-3"
                    v-if="
                      company.type === 'iom_1931_act_company_limited_by_shares'
                    "
                  >
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Reporting details</h4>
                      <p class="text-muted">
                        These details are used to prepare the company's Annual
                        Return form.
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <small class="form-text text-muted mb-2">
                        As defined by the
                        <a
                          href="https://www.tynwald.org.im/business/opqp/sittings/20112014/2013-SD-0242.pdf"
                          target="_blank"
                          >Companies (Fees and Duties) Order 2013 (SD242/13)</a
                        >:
                      </small>
                      <!-- Is charity? -->
                      <b-row class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom"
                            >Is the company a charity?</label
                          >
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="company.details.isCharity"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- Is excepted company? -->
                      <b-row class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom"
                            >Is the company an excepted company?</label
                          >
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="company.details.isExceptedCompany"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <hr />

                      <!-- Timeshare -->
                      <small class="form-text text-muted mb-2">
                        As defined in Section 20 of the
                        <a
                          href="https://legislation.gov.im/cms/images/LEGISLATION/PRINCIPAL/1996/1996-0007/TimeshareAct1996_3.pdf"
                          target="_blank"
                          >Timeshare Act 1996</a
                        >:
                      </small>
                      <!-- Is Timeshare Stakeholder? -->
                      <b-row class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom"
                            >Is the company a timeshare stakeholder?</label
                          >
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="
                              company.details.timeshareStakeholder
                                .isTimeshareStakeholder
                            "
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- Has issued paid up shares? -->
                      <b-row
                        v-if="
                          company.details.timeshareStakeholder
                            .isTimeshareStakeholder
                        "
                        class="mb-2"
                      >
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Has the company issued shares fully paid up in cash
                            of the minimum nominal value required by section
                            109(3B)(a) of the
                            <a
                              href="https://legislation.gov.im/cms/images/LEGISLATION/PRINCIPAL/1931/1931-0002/CompaniesAct1931_10.pdf"
                              target="_blank"
                              >Companies Act 1931</a
                            >?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="
                              company.details.timeshareStakeholder
                                .hasIssuedPaidUpShares
                            "
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- has indemnity insurance -->
                      <b-row
                        v-if="
                          company.details.timeshareStakeholder
                            .isTimeshareStakeholder
                        "
                        class="mb-2"
                      >
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Does the company hold indemnity insurance, for such
                            sum and in respect of such liabilities as are
                            specified in section 109 (3B)(b) of the
                            <a
                              href="https://legislation.gov.im/cms/images/LEGISLATION/PRINCIPAL/1931/1931-0002/CompaniesAct1931_10.pdf"
                              target="_blank"
                              >Companies Act 1931</a
                            >?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="
                              company.details.timeshareStakeholder
                                .hasIndemnityInsurance
                            "
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <hr />

                      <small class="form-text text-muted mb-2">
                        With regards to the
                        <a
                          href="https://legislation.gov.im/cms/images/LEGISLATION/PRINCIPAL/2017/2017-0003/BeneficialOwnershipAct2017_4.pdf"
                          target="_blank"
                          >Beneficial Ownership Act 2017</a
                        >:
                      </small>
                      <!-- Beneficial Ownership Act Is Applicable? -->
                      <b-row class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Does the Beneficial Ownership Act apply to the
                            company?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="
                              company.details.beneficialOwnershipAct
                                .isApplicable
                            "
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- Is listed entity? -->
                      <b-row
                        class="mb-2"
                        v-if="
                          !company.details.beneficialOwnershipAct.isApplicable
                        "
                      >
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Is the company listed on a stock or investment
                            exchange recognised by the Treasury?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="
                              company.details.beneficialOwnershipAct
                                .isListedEntity
                            "
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- Is listed entity subsidiary? -->
                      <b-row
                        class="mb-2"
                        v-if="
                          !company.details.beneficialOwnershipAct.isApplicable
                        "
                      >
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Is the company a wholly owned subsidiary of a legal
                            entity listed on a stock or investment exchange
                            recognised by Treasury, where the disclosure
                            obligations on the legal entity include beneficial
                            ownership information in respect of the entity and
                            its subsidiaries?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="
                              company.details.beneficialOwnershipAct
                                .isListedEntitySubsidiary
                            "
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- treasury Order Applies -->
                      <b-row
                        class="mb-2"
                        v-if="
                          !company.details.beneficialOwnershipAct.isApplicable
                        "
                      >
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Does an Order made by the Treasury under section
                            5(4) of the Beneficial Ownership Act 2017 apply to
                            the company?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="
                              company.details.beneficialOwnershipAct
                                .treasuryOrderApplies
                            "
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- treasury order details -->
                      <b-row
                        class="mb-2"
                        v-if="
                          !company.details.beneficialOwnershipAct
                            .isApplicable &&
                          company.details.beneficialOwnershipAct
                            .treasuryOrderApplies
                        "
                      >
                        <b-col>
                          <base-input
                            label="Which Treasury Order applies to the company?"
                            name="Treasury Order"
                            :rules="{
                              required:
                                !company.details.beneficialOwnershipAct
                                  .isApplicable &&
                                company.details.beneficialOwnershipAct
                                  .treasuryOrderApplies,
                            }"
                            :debounce="500"
                            placeholder="Treasury Order details"
                            v-model="
                              company.details.beneficialOwnershipAct
                                .treasuryOrderDetails
                            "
                          ></base-input>
                        </b-col>
                      </b-row>

                      <hr />

                      <small class="form-text text-muted mb-2">
                        In respect of all mortgages and charges of the kind
                        which are required to be registered with the Department
                        of Economic Development:
                      </small>

                      <b-row>
                        <b-col cols="6">
                          <label class="form-control-label align-bottom">
                            What is the total amount of indebtedness of the
                            company?
                          </label>
                        </b-col>

                        <b-col>
                          <currency-input
                            class="form-control"
                            v-model="company.details.indebtedness"
                            :currency="company.currency"
                            :value-as-integer="true"
                          />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
                <b-card-footer>
                  <b-row>
                    <b-col>
                      <b-btn @click="$router.go(-1)">
                        <i class="fa fa-times mr-2"></i> Cancel
                      </b-btn>
                      <base-button @click="deleteCompany" type="danger" outline>
                        <i class="fa fa-trash mr-2"></i> Delete company
                      </base-button>
                    </b-col>
                    <b-col class="text-right">
                      <span v-if="!valid" class="text-danger mr-4"
                        >Please complete all required fields.</span
                      >
                      <base-button native-type="submit" :disabled="!valid">
                        <span v-if="!saving">
                          Save company
                          <i class="fa fa-arrow-right ml-2"></i>
                        </span>
                        <span v-else>
                          <i class="fa fa-spin fa-spinner mr-2"></i> Please
                          wait&hellip;
                        </span>
                      </base-button>
                    </b-col>
                  </b-row>
                </b-card-footer>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import currencies from "currency-codes";
import _ from "underscore";
import moment from "moment";
import { get } from "dot-prop";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import AddressAutocompleteInput from "../../Forms/AddressAutocompleteInput";

export default {
  name: "company-create",
  components: {
    StatsCard,
    RouteBreadCrumb,
    Loading,
    AddressAutocompleteInput,
  },
  props: {
    companyId: {
      type: String,
      description: "Company ID",
      required: true,
    },
  },
  data() {
    return {
      company: null,
      loading: false,
      currencies: currencies.data,
      yearEndMonth: "01",
      yearEndDay: "01",
      errorMessage: null,
      errors: {},
      saving: false,
    };
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    },
    yearEndDays: function () {
      const days = [];
      _.times(31, (n) => {
        let d = n + 1;
        if (this.yearEndMonth === "02") {
          // 28 days in Feb
          if (d > 28) {
            return;
          }
        } else if (_.contains(["04", "06", "09", "11"], this.yearEndMonth)) {
          if (d > 30) {
            return;
          }
        }

        const twoDigitDate = d.toString().padStart(2, "0");
        return days.push({
          value: twoDigitDate,
          label: moment(twoDigitDate, "DD").format("Do"),
          disabled: false,
        });
      });

      return days;
    },
  },
  beforeMount() {
    this.loading = true;
    this.axios
      .get(`/v1/accounts/${this.account.id}/companies/${this.companyId}`)
      .then((response) => {
        this.loading = false;

        this.company = response.data;

        // set computed fields
        const date = moment(this.company.nextYearEndDate, "YYYY-MM-DD");
        this.yearEndMonth = date.format("MM");
        this.yearEndDay = date.format("DD");
      })
      .catch((error) => {
        this.loading = false;
        this.errorMessage = "Failed to load company";
        if (get(error, "response.data.message")) {
          this.errorMessage = error.response.data.message;
        }
      });
  },
  watch: {
    // TODO: watch country change and set currency code e.g. cc.country('colombia')
  },
  methods: {
    updateCompany: function () {
      const ignoreFields = [
        "id",
        "nextYearEndDate",
        "createdAt",
        "archivedAt",
        "updatedAt",
        "creatorId",
        "accountId",
        "shareMovements",
        "beneficialOwnershipOfficer",
        "directors",
        "secretaries",
        "shareClasses",
        "shareholders",
      ];
      const requestBody = _.omit(this.company, ignoreFields);

      if (this.yearEndMonth && this.yearEndDay) {
        requestBody.yearEndDate = `${this.yearEndMonth}-${this.yearEndDay}`;
      }

      // send the request
      this.saving = true;
      this.axios
        .patch(
          `/v1/accounts/${this.account.id}/companies/${this.company.id}`,
          requestBody
        )
        .then((response) => {
          this.saving = false;
          // notify
          this.$notify({
            message: "Company updated",
            timeout: 3000,
            icon: "fa fa-check",
            type: "success",
          });

          this.$router.push(`/companies/${response.data.id}`);
        })
        .catch((error) => {
          this.saving = false;
          this.errorMessage = "Failed to update company";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    },
    deleteCompany() {
      swal
        .fire({
          title: "Are you sure?",
          text: "This company will be deleted",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "gray",
          confirmButtonText: "Yes, delete!",
          reverseButtons: true,
          showLoaderOnConfirm: true,
          preConfirm: (login) => {
            return this.axios
              .delete(
                `/v1/accounts/${this.company.accountId}/companies/${this.company.id}`
              )
              .then((response) => {
                return response;
              })
              .catch((error) => {
                swal.showValidationMessage(
                  `Request failed: ${error.response.data.message}`
                );
              });
          },
          allowOutsideClick: () => !swal.isLoading(),
        })
        .then((result) => {
          if (result.value) {
            swal.fire("Done!", "The company was deleted", "success");
            // redirect to dashboard
            this.$router.push(`/dashboard`);
          }
        });
    },
  },
};
</script>
<style>
.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
